import React, { useContext, useState, useEffect } from "react";
import style from "../style/ResetPassword.module.scss";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import { Button } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { LoginContext } from "../contexts/LoginContext";
import { useMutation } from "react-query";
import apiClient from "../libraries/ApiClient";

const CssTextField = styled((props) => <TextField {...props} fullWidth />)(
  ({ theme }) => ({
    "& .MuiFilledInput-root": {
      border: "1px solid #e2e2e1",
      overflow: "hidden",
      borderRadius: 4,
      backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:hover:not(.Mui-disabled):before": {
        borderBottom: "none",
      },
      "&:before": {
        border: "none",
      },
      "&:after": {
        border: "none",
      },
      "&.Mui-focused": {
        backgroundColor: "transparent",
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
        borderColor: theme.palette.primary.main,
      },
    },
  })
);

const CssButton = styled(Button)({
  fontSize: 16,
  backgroundColor: "#057AFF",
  "&:disabled": {
    border: "1px solid #818181",
    color: "#818181",
    background: "#E0E0E0",
  },
  "&:hover": {
    backgroundColor: "#1570EF",
    cursor: "pointer",
  },
});

function ResetPassword() {
  const navigate = useNavigate();
  const [openEye, setOpenEye] = useState(false);

  const {
    mailValue,
    passwordValue,
    passwordValueIsValid,
    hasPasswordError,
    onChangePasswordValue,
    onBlurPasswordValue,
  } = useContext(LoginContext);
  //console.log(mailValue);

  const sendPasswordData = async ({ mailValue, passwordValue }) => {
    const data = {
      Data: {
        Type: 1,
        AccountRowId: "Null",
        Account: mailValue,
        OldPassword: "Null",
        NewPassword: passwordValue,
        ConfirmPassword: passwordValue,
      },
    };


    const res = await apiClient.postAes("api/login/Reset/security", data);
    if (res.status !== 200) {
      alert("更改失敗");
      return;
    } else {
      return res.data;
    }
  };

  const { mutate } = useMutation(sendPasswordData, {
    onSuccess: (data) => {
      const { Code, Message } = data;

      if (+Code === 0) {
        alert(Message);
        navigate("/Login");
      } else {
        alert(Message);
      }
    },
  });

  return (
    <div className={style.ResetPassword_body}>
      <div className={style.ResetPassword_background}></div>
      <svg
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1921 273"
        className={style.triangle}
      >
        <polygon fill="#fff" points="0,273 1921,273 1921,0 "></polygon>
      </svg>
      <div className={style.ResetPassword_form_body}>
        <div className={style.logo}>
          <img src="/end_logo.svg" alt="" style={{ width: "20%" }} />
        </div>
        <div className={style.ResetPassword_form}>
          <div className={style.ResetPassword_form_top}>
            <div className={style.ResetPassword_title}>請修改密碼</div>
            <div className={style.ResetPassword_little_title}>
              密碼修改後，請以新密碼登入！
            </div>
          </div>
          <div className={style.input_content}>
            <div className={style.input_mail}>
              <CssTextField
                label="請輸入密碼(英數至少8碼的組合)"
                variant="filled"
                type={`${openEye ? null : "password"}`}
                onChange={onChangePasswordValue}
                onBlur={onBlurPasswordValue}
                error={hasPasswordError}
                value={passwordValue}
                style={{ width: "100%" }}
              />
              <i
                className={`fa-solid ${style.eye_btn} ${
                  openEye ? "fa-eye" : "fa-eye-slash"
                }`}
                onClick={() => {
                  setOpenEye(!openEye);
                }}
              ></i>
              <div
                style={{ color: "#EB4D3D", fontSize: "13px", padding: "4px" }}
              >
                {hasPasswordError &&
                  "密碼請輸入英數組合至少8碼，避免特殊符號或空白"}
              </div>
            </div>

            <div className={style.btn}>
              <CssButton
                variant="contained"
                onClick={() => {
                  mutate({ mailValue, passwordValue });
                }}
                disabled={!passwordValueIsValid}
              >
                確認
              </CssButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
